import React from 'react';
import { Box, styled } from '@mui/material';

// Cabecera del sidebar: logo + botón colapsar/cerrar. En rail (iconOnly) se apila
// en columna porque a 84px no caben lado a lado.
const StyledSidebarHeader = styled(({ iconOnly, ...otherProps }) => <Box {...otherProps} />)(
  ({ iconOnly, theme }) => ({
    alignItems: 'center',
    display: 'flex',
    flexDirection: iconOnly ? 'column' : 'row',
    gap: theme.spacing(1),
    justifyContent: iconOnly ? 'center' : 'space-between',
    marginBottom: theme.spacing(1.5),
    minHeight: 40
  })
);

export default StyledSidebarHeader;
